/* Small pieces shared by the Stats cards. */

/* The theme has no amber/gold/blue tokens; these are tuned per theme so the
 * text stays readable on white as well as on the dark cards. */
export function extraColors(isDark) {
  return isDark
    ? { gold: '#fbbf24', goldSoft: 'rgba(251, 191, 36, 0.14)', amber: '#f59e0b', amberSoft: 'rgba(245, 158, 11, 0.14)', blue: '#60a5fa', blueSoft: 'rgba(96, 165, 250, 0.14)' }
    : { gold: '#a16207', goldSoft: 'rgba(234, 179, 8, 0.16)', amber: '#b45309', amberSoft: 'rgba(217, 119, 6, 0.12)', blue: '#2563eb', blueSoft: 'rgba(37, 99, 235, 0.10)' };
}

/* The gold of the PR dots: the chart needs a fill that pops on both themes. */
export const PR_DOT = '#fbbf24';

export function CardTitle({ t, children, sub, right }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: t.text }}>{children}</div>
        {sub && <div style={{ fontSize: 11, color: t.textFaint, marginTop: 3, lineHeight: 1.4 }}>{sub}</div>}
      </div>
      {right}
    </div>
  );
}

/* Pill toggle group. 40px tall: it gets used one-handed between sets. */
export function PillGroup({ t, options, value, onChange, label }) {
  return (
    <div role="group" aria-label={label} style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {options.map(o => {
        const active = value === o.id;
        return (
          <button key={o.id} type="button" aria-pressed={active} onClick={() => onChange(o.id)} style={{
            minHeight: 40, padding: '0 14px', borderRadius: 999,
            border: `1px solid ${active ? t.accent : t.cardBorder}`,
            background: active ? t.accentSoft : 'transparent',
            color: active ? t.accent : t.textMuted,
            fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
          }}>{o.label}</button>
        );
      })}
    </div>
  );
}

export function EmptyNote({ t, children }) {
  return (
    <div style={{ fontSize: 13, color: t.textMuted, textAlign: 'center', padding: '20px 0', lineHeight: 1.5 }}>
      {children}
    </div>
  );
}

/* Full-width text button for "show more" style toggles. */
export function MoreButton({ t, onClick, children }) {
  return (
    <button type="button" onClick={onClick} style={{
      width: '100%', minHeight: 40, marginTop: 8, borderRadius: 8,
      background: 'transparent', border: `1px dashed ${t.cardBorder}`, color: t.textMuted,
      fontSize: 12, fontWeight: 600, cursor: 'pointer',
    }}>{children}</button>
  );
}

/* Full-width segmented control for switching a whole view. */
export function Segmented({ t, options, value, onChange, label }) {
  return (
    <div role="tablist" aria-label={label} style={{
      display: 'flex', gap: 4, padding: 4, borderRadius: 12,
      background: t.surfaceAlt, border: `1px solid ${t.cardBorder}`,
    }}>
      {options.map(o => {
        const active = value === o.id;
        return (
          <button key={o.id} type="button" role="tab" aria-selected={active} onClick={() => onChange(o.id)} style={{
            flex: 1, minHeight: 40, borderRadius: 9, cursor: 'pointer',
            border: `1px solid ${active ? t.accentBorder : 'transparent'}`,
            background: active ? t.accentSoft : 'transparent',
            color: active ? t.accent : t.textMuted,
            fontSize: 13, fontWeight: 700,
          }}>{o.label}</button>
        );
      })}
    </div>
  );
}
